/* eslint-disable */
import React from 'react';
import * as MUI from '@material-ui/core';
import cn from 'classnames';
import FullscreenIcon from '../../../../../icons/Fullscreen';
import { Theme, createStyles, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
    },
    drawer: {
      minHeight: '100vh',
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
    },
    toolbar: {
      float: 'right',
      paddingRight: theme.spacing(4)
    }
  })
);

export function Fullscreen(props) {
  const classes = useStyles(props);
  const classNameButton = cn(classes.button);

  const [state, setState] = React.useState({
    open: false,
  });

  const toggleDrawer = open => event => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, open });
  };

  return (<>
    <MUI.IconButton className={classNameButton} aria-label="Full screen" onClick={toggleDrawer(true)}>
      <FullscreenIcon />
    </MUI.IconButton>
    <Drawer open={state.open} elementId='report-layout' onClose={toggleDrawer(false)} />
  </>);
}

function Drawer(props: { open: boolean, elementId: string, onClose: Function }) {
  const classes = useStyles(props);
  const { open, elementId, onClose } = props;
  const ref = React.createRef<HTMLDivElement>();
  React.useEffect(() => {
    setTimeout(() => {
      const current = ref.current || document.getElementById("drawer-report-fullscreen") as HTMLElement;
      if (current) {
        const node = document.getElementById(elementId) as HTMLElement;
        if (node) {
          if (open) {
            while (node.childNodes.length) {
              const childeNode = node.childNodes[0];
              current.appendChild(childeNode);
            }
          } else {
            while (current.childNodes.length) {
              const childeNode = current.childNodes[0];
              node.appendChild(childeNode);
            }
          }
        }
      }
    }, 40);
  }, [open]);

  return (
    <MUI.Drawer anchor="bottom" open={open} onClose={onClose as any} >
      <MUI.Paper className={classes.drawer}>
        <MUI.Toolbar className={classes.toolbar}>
          <MUI.IconButton className={classes.button} aria-label="Full screen" onClick={onClose as any}>
            <FullscreenIcon />
          </MUI.IconButton>
        </MUI.Toolbar>

        <div id="drawer-report-fullscreen" ref={ref}></div>
      </MUI.Paper>
    </MUI.Drawer>
  );
}